export default __webpack_public_path__ + "static/consultation-teaser-person-80044b22811b8c03e74bcad65ec82f6f.jpg";